module.exports = __webpack_public_path__ + "img/Profil_VP-Classic.50cc7baf.jpg";